import { Type, type Static } from "@sinclair/typebox";
export const ReferralInvoiceAssignSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    intakeId: Type.String({ format: "uuid" }),
    administratorId: Type.String({ format: "uuid" }),
    rememberSupplier: Type.Boolean(),
    keyword: Type.String({ minLength: 4, maxLength: 100 }),
  },
  { additionalProperties: false },
);
export type ReferralInvoiceAssign = Static<typeof ReferralInvoiceAssignSchema>;
export const ReferralRuleDisableSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    ruleId: Type.String({ format: "uuid" }),
  },
  { additionalProperties: false },
);
export type ReferralRuleDisable = Static<typeof ReferralRuleDisableSchema>;
export interface ReferralCommissionDashboard {
  companyId: string | null;
  administrators: Array<{
    id: string;
    name: string;
    collectedGross: string;
    payableNet: string;
  }>;
  commissions: Array<{
    id: string;
    jobId: string;
    jobCode: string;
    administratorId: string;
    componentNet: string;
    collectedGross: string;
    payableNet: string;
    earned: boolean;
    reason: string;
    checkedAt: string | null;
  }>;
  invoices: Array<{
    id: string;
    supplier: string;
    number: string | null;
    date: string;
    net: string;
    credit: boolean;
    review: boolean;
    supplierKey: string | null;
    description: string;
    administratorId: string | null;
  }>;
  rules: Array<{
    id: string;
    administratorId: string;
    supplierName: string;
    keyword: string;
  }>;
  movements: Array<{
    id: string;
    administratorId: string;
    kind: string;
    netDelta: string;
    grossDelta: string;
    date: string;
    jobCode: string | null;
    invoiceNumber: string | null;
  }>;
}
